<template>
  <div class="imdf">
    <HeaderStyle1 class-name="imdf-header">
      <h1 slot="title" v-html="$t('imdf-head-h1')"></h1>
      <p slot="detail" v-html="$t('imdf-head-small')"></p>
      <b-img class="header-img" slot="image" src="../assets/imgs/head-img-imdf.png"
             alt=""></b-img>
    </HeaderStyle1>

    <b-container fluid="xl">
      <b-row class="section-1">
        <b-col class="row-content"
               cols="12"
               xl="6"
               md="6"
               sm="12"
        >
          <h5 class="row-title">{{$t('imdf-item-1-title')}}</h5>
          <p class="row-detail" v-html="$t('imdf-item-1-detail')"></p>
        </b-col>
        <b-col cols="1"
               xl="1"
               md="1"
               sm="0"
               align-v="center"
        ></b-col>
        <b-col
          style="text-align: center"
          cols="12"
          xl="5"
          md="5"
          sm="12"
        >
          <b-img style="width: 80%;" src="../assets/imgs/imdf-item-1-img.png" fluid></b-img>
        </b-col>
      </b-row>

      <h3 class="section-2-title">{{$t('section-2-title')}}</h3>

      <b-row class="section-2">
        <b-col cols="12" xl="6" md="6" sm="12">
          <b-img src="../assets/imgs/imdf-row-1-img.png" alt="" />
          <h4 v-html="$t('imdf-horizontal-item-1-title')"></h4>
          <p v-html="$t('imdf-horizontal-item-1-content')"></p>
        </b-col>
        <b-col cols="12" xl="6" md="6" sm="12">
          <b-img src="../assets/imgs/imdf-row-2-img.png" alt="" />
          <h4 v-html="$t('imdf-horizontal-item-2-title')"></h4>
          <p v-html="$t('imdf-horizontal-item-2-content')"></p>
        </b-col>
        <b-col cols="12" xl="6" md="6" sm="12">
          <b-img src="../assets/imgs/imdf-row-3-img.png" alt="" />
          <h4 v-html="$t('imdf-horizontal-item-3-title')"></h4>
          <p v-html="$t('imdf-horizontal-item-3-content')"></p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HeaderStyle1 from '../components/HeaderStyles1.vue'

export default {
  name: 'IMDF',
  components: {
    HeaderStyle1
  }
}
</script>

<style scoped lang="scss">
  .imdf {
    padding-bottom: 90px;
    .header-img {
      max-width: 35%;
      margin-bottom: 30px;
    }

    .section-1 {
      margin-top: 100px;
      justify-content: center
    }

    .row-title {
      font-size: 34px;
      font-weight: 700;
      color: #000000;
      margin-bottom: 30px;
    }

    .section-2-title {
      font-size: 34px;
      font-weight: 700;
      color: #000000;
      margin-top: 30px;
    }

    .section-2 {
      margin-top: 112px;
      text-align: center;

      img {
        height: 93px;
      }

      h4 {
        margin-top: 46px;
        font-size: 20px;
        font-weight: 700;
        color: #000000;
      }

      p {
        opacity: 0.8;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        margin-top: 36px;
      }
    }
  }
</style>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .imdf-header {
      height: 500px !important;
    }
    .header-img {
      max-width: 35%;
      margin-bottom: 10px !important;
    }
    .section-1 {
      margin-top: 20px !important;

      .row-title {
        font-size: 18px !important;
        margin-bottom: 10px !important;
      }
      .row-detail {
        font-size: 14px !important;
      }
    }
    .section-2-title {
      font-size: 18px !important;
    }
    .section-2 {
      margin-top: 30px !important;

      img {
        margin-top: 20px !important;
      }

      h4 {
        margin-top: 20px !important;
      }
    }
  }
</style>
